import { connect } from 'react-redux';
import EnrichmentLanding from './components/EnrichmentLanding';
import {
  loadScoreDetails,
  loadMergeAPIIPDetails,
  loadMergeAPIDomainDetails,
  loadMergeAPIExploreDetails,
  loadMergeAPIExploreDensity,
  clearExploreDetails,
  resetEnrichment,
} from '../../redux/actions/ioc';
import { loadUser, loadMySubscriptionPlan } from '../../redux/actions/user';

const mapStateToProps = (state) => ({
  status: state.ioc.detailsStatus,
  scoreDetails: state.ioc.scoreDetails,
  mergeAPIscoreDetails: state.ioc.mergeAPIscoreDetails,
  exploreAPIscoreDetails: state.ioc.exploreAPIscoreDetails,
  exploreAPIDensityDetails: state.ioc.exploreAPIDensityDetails,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
});

const mapDispatchToProps = {
  loadUser,
  loadScoreDetails,
  loadMergeAPIIPDetails,
  loadMergeAPIDomainDetails,
  loadMergeAPIExploreDetails,
  loadMergeAPIExploreDensity,
  clearExploreDetails,
  resetEnrichment,
  loadMySubscriptionPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(EnrichmentLanding);
